import { motion } from "motion/react";
import styles from "./login.module.css";
import { loginVariantsDuration } from "../../routesVariants";

export default function Logo({ expanded }) {
  return (
    <div className={styles.logoLoginContainer}>
      <motion.img
        initial={{ y: 50, x: 10, rotate: 15, opacity: 0 }}
        animate={{
          y: 0,
          x: 0,
          rotate: 0,
          opacity: expanded ? 0 : 1,
        }}
        src="img/logo_large.png"
        alt="GravizApp"
        className={styles.logoLogin}
      />
    </div>
  );
}
